var map = {
	"./homePage/index.vue": [
		"xcJn"
	],
	"./homePage/payment.vue": [
		"4TtM",
		8,
		0
	],
	"./homePage/pintuangouDet.vue": [
		"H9Df",
		6,
		0
	],
	"./homePage/placeOrder.vue": [
		"S+E4",
		0,
		10
	],
	"./homePage/productDetails.vue": [
		"iYDf",
		5,
		0
	],
	"./homePage/productList.vue": [
		"lVYd",
		0,
		15
	],
	"./homePage/productList2.vue": [
		"9xIe",
		0,
		11
	],
	"./homePage/vueMchat.vue": [
		"2531",
		2
	],
	"./login/login.vue": [
		"W2Q3",
		7,
		0
	],
	"./login/xieyi.vue": [
		"LZ6w",
		14
	],
	"./login/yinsi.vue": [
		"CW6c",
		13
	],
	"./order/empty.vue": [
		"98s3",
		4,
		0
	],
	"./order/information.vue": [
		"w2AQ",
		9
	],
	"./order/order.vue": [
		"Vg+r",
		1,
		0
	],
	"./order/orderDetails.vue": [
		"UKK+",
		12
	],
	"./shoppingCar/index.vue": [
		"1loq",
		16
	],
	"./shoppingCar/shopCartOrder.vue": [
		"My7n",
		3,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 18